import React from "react";
import VisibleResults from "./results-type/VisibleResults.js";
import FilterResults from "./results-type/FilterResults.js";
import StateResults from "./results-type/StateResults.js";
import NationalResults from "./results-type/NationalResults.js";
import SelectedResult from "./results-type/SelectedResult.js";
import viewMapIcon from "../../assets/images/icons/viewMap.svg";

const SearchResults = props => {
  const {
    results,
    visibleResults,
    stateLocations,
    nationalMarkers,
    nationalFilter,
    currentView,
    currentLocation,
    updateMapView,
    selectedResult,
    isMobile,
    mapRef,
    setSelectedMarker,
    selectedPinData
  } = props;

  const handleViewMap = () => {
    updateMapView();
  };

  window.onload = function() {
    var hostname = window.location.host;
    let analyticsScript = document.createElement("script");
    if (
      hostname.includes("pfizerstatic.io") ||
      hostname.includes("localhost")
    ) {
      analyticsScript.setAttribute(
        "src",
        "//assets.adobedtm.com/22baa8e94be8/4055f9a24646/launch-fe59197b1c76-development.min.js"
      );
    } else {
      analyticsScript.setAttribute(
        "src",
        "//assets.adobedtm.com/22baa8e94be8/4055f9a24646/launch-14db66d3cfa7.min.js"
      );
    }
    analyticsScript.async = true;
    document.head.appendChild(analyticsScript);
  };

  // useEffect(() => {
  //   //console.log(selectedPinData);
  //   console.log(selectedResult.mapClick);
  // }),
  //   [selectedResult];

  return (
    <div className="searchResults">
      {currentView.expandView && !isMobile ? (
        <button className={"viewMapBtn"} onClick={() => handleViewMap()}>
          <span className={"copy"}>View Map</span>
          <img alt="White Circle in black location mark" src={viewMapIcon} />
        </button>
      ) : null}

      <div className="resultsContainer">
        {/* visible pins results after search */}
        {visibleResults.length === 0 &&
        results.length === 0 &&
        stateLocations.length === 0 &&
        selectedResult.mapClick === false ? (
          <p className="noResultTxt">
            <b>We can&apos;t find anything matching your search criteria.</b>
            <br></br>Try adjusting the distance or searching with a new city,
            state, or zip code.<br></br>
            <br></br>You can also check out the National Organizations below:
          </p>
        ) : null}

        {selectedResult.mapClick === true ? (
          <div>
            <SelectedResult
              selectedPinData={selectedPinData}
              currentLocation={currentLocation}
              selectedResult={selectedResult}
              mapRef={mapRef}
              setSelectedMarker={setSelectedMarker}
            />
            <NationalResults
              nationalMarkers={nationalMarkers}
              selectedResult={selectedResult}
              currentLocation={currentLocation}
              mapRef={mapRef}
              setSelectedMarker={setSelectedMarker}
            />
          </div>
        ) : null}

        {nationalFilter ? (
          <NationalResults
            nationalMarkers={nationalMarkers}
            selectedResult={selectedResult}
            currentLocation={currentLocation}
            mapRef={mapRef}
            setSelectedMarker={setSelectedMarker}
          />
        ) : null}

        {selectedResult.mapClick === false ? (
          <div>
            <FilterResults
              results={results}
              currentLocation={currentLocation}
              selectedResult={selectedResult}
              mapRef={mapRef}
              setSelectedMarker={setSelectedMarker}
            />

            <StateResults
              stateLocations={stateLocations}
              currentLocation={currentLocation}
              selectedResult={selectedResult}
              mapRef={mapRef}
              setSelectedMarker={setSelectedMarker}
            />
          </div>
        ) : null}

        {/* hide visible results when filtering */}
        {/* also hide default national results */}
        {results.length > 0 ||
        stateLocations.length > 0 ||
        nationalFilter == true ||
        selectedResult.mapClick === true ? null : (
          <div>
            <VisibleResults
              visibleResults={visibleResults}
              currentLocation={currentLocation}
              selectedResult={selectedResult}
              mapRef={mapRef}
              setSelectedMarker={setSelectedMarker}
            />

            <NationalResults
              nationalMarkers={nationalMarkers}
              selectedResult={selectedResult}
              currentLocation={currentLocation}
              mapRef={mapRef}
              setSelectedMarker={setSelectedMarker}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchResults;
